/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type MarketplaceBuyDirectStatus =
  | 'AVAILABLE'
  | 'BACKUP_OFFER'
  | 'IN_CONTRACT'
  | 'OFFER_DEADLINE';

export type MarketplaceDisplayBadge =
  | 'AVAILABLE_SOON'
  | 'IN_CONTRACT'
  | 'ON_THE_MARKET'
  | 'RECENTLY_SOLD'
  | 'TEMPORARILY_UNAVAILABLE'
  | 'TRADITIONAL'
  | 'UNKNOWN';

export type MarketplaceDwellingType =
  | 'CONDO'
  | 'HOUSE'
  | 'MULTI_FAMILY'
  | 'OTHER'
  | 'TOWNHOUSE';

export type MarketplaceKitchenCountertop =
  | 'CORIAN'
  | 'FORMICA'
  | 'GRANITE_SLAB'
  | 'GRANITE_TILE'
  | 'OTHER_TILE'
  | 'QUARTZ'
  | 'UNKNOWN';

export type MarketplaceListingHistoryState =
  | 'COMING_SOON'
  | 'FOR_SALE'
  | 'OFF_MARKET'
  | 'SALE_PENDING'
  | 'SOLD'
  | 'UNKNOWN'
  | 'WITHDRAWN';

export type MarketplaceListingState =
  | 'AVAILABLE_SOON'
  | 'IN_CONTRACT'
  | 'ON_THE_MARKET'
  | 'RECENTLY_SOLD'
  | 'UNKNOWN';

export type MarketplacePrimaryBedroomLocation =
  | 'BASEMENT'
  | 'FIRST_FLOOR'
  | 'SECOND_FLOOR'
  | 'THIRD_FLOOR'
  | 'UNKNOWN';

export type GetMarketplacePropertyDetailsQueryVariables = Exact<{
  addressId: Types.Scalars['UUID']['input'];
  includeSimilarListings: Types.Scalars['Boolean']['input'];
}>;


export type GetMarketplacePropertyDetailsQuery = { marketplace: { listingDetails: { description: Types.Scalars['String']['output'] | null, exteriorStories: Types.Scalars['SafeInt']['output'] | null, garageSpaces: Types.Scalars['SafeInt']['output'] | null, kitchenCountertop: Types.MarketplaceKitchenCountertop | null, primaryBedroomLocation: Types.MarketplacePrimaryBedroomLocation | null, schoolDistricts: Array<Types.Scalars['NonEmptyString']['output']> | null, shouldShowGuarantee: Types.Scalars['Boolean']['output'], unitNumber: Types.Scalars['String']['output'] | null, unitType: Types.Scalars['String']['output'] | null, availability: { canSelfTour: Types.Scalars['Boolean']['output'] | null, displayBadge: Types.MarketplaceDisplayBadge, state: Types.MarketplaceListingState } | null, buyDirect: { priceCents: Types.Scalars['SafeInt']['output'], savingsCents: Types.Scalars['SafeInt']['output'] | null, status: Types.MarketplaceBuyDirectStatus } | null, floorPlanPhotos: Array<{ label: Types.Scalars['NonEmptyString']['output'], url: Types.Scalars['URL']['output'] }>, listingHistory: Array<{ currentListPriceCents: Types.Scalars['SafeInt']['output'] | null, mls: Types.Scalars['String']['output'] | null, originalListPriceCents: Types.Scalars['SafeInt']['output'] | null, soldPriceCents: Types.Scalars['SafeInt']['output'] | null, state: Types.MarketplaceListingHistoryState, timestamp: Types.Scalars['DateTime']['output'] | null }> | null, schools: Array<{ id: Types.Scalars['ID']['output'], name: Types.Scalars['NonEmptyString']['output'], rating: Types.Scalars['SafeInt']['output'] | null }> | null, similarListings?: Array<{ addressId: Types.Scalars['UUID']['output'], bathrooms: Types.Scalars['Float']['output'] | null, bedrooms: Types.Scalars['SafeInt']['output'] | null, city: Types.Scalars['String']['output'] | null, dwellingType: Types.MarketplaceDwellingType, estimatedMonthlyPaymentCents: Types.Scalars['SafeInt']['output'] | null, fullAddress: Types.Scalars['String']['output'] | null, listPriceCents: Types.Scalars['SafeInt']['output'] | null, neighborhood: Types.Scalars['String']['output'] | null, photoUrls: Array<Types.Scalars['URL']['output']>, slug: Types.Scalars['String']['output'] | null, totalLivingSquareFootage: Types.Scalars['SafeInt']['output'] | null }> | null, photos: Array<{ extraLargeUrl: Types.Scalars['URL']['output'], largeUrl: Types.Scalars['URL']['output'], mediumUrl: Types.Scalars['URL']['output'] }>, summary: { addressId: Types.Scalars['UUID']['output'], bathrooms: Types.Scalars['Float']['output'] | null, bedrooms: Types.Scalars['SafeInt']['output'] | null, canSelfTour: Types.Scalars['Boolean']['output'] | null, city: Types.Scalars['String']['output'] | null, displayBadge: Types.MarketplaceDisplayBadge, dwellingType: Types.MarketplaceDwellingType, estimatedMonthlyPaymentCents: Types.Scalars['SafeInt']['output'] | null, latitude: Types.Scalars['Latitude']['output'] | null, listPriceCents: Types.Scalars['SafeInt']['output'] | null, listingState: Types.MarketplaceListingState, longitude: Types.Scalars['Longitude']['output'] | null, lotSquareFootage: Types.Scalars['SafeInt']['output'] | null, pricePerSquareFootCents: Types.Scalars['SafeInt']['output'] | null, slug: Types.Scalars['String']['output'] | null, state: Types.Scalars['String']['output'] | null, street: Types.Scalars['String']['output'] | null, totalLivingSquareFootage: Types.Scalars['SafeInt']['output'] | null, yearBuilt: Types.Scalars['SafeInt']['output'] | null, zip: Types.Scalars['String']['output'] | null } } | null } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const GetMarketplacePropertyDetailsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query GetMarketplacePropertyDetails($addressId: UUID!, $includeSimilarListings: Boolean!) {
  marketplace {
    listingDetails(addressId: $addressId) {
      availability {
        canSelfTour
        displayBadge
        state
      }
      buyDirect {
        priceCents
        savingsCents
        status
      }
      description
      exteriorStories
      floorPlanPhotos {
        label
        url
      }
      garageSpaces
      kitchenCountertop
      listingHistory {
        currentListPriceCents
        mls
        originalListPriceCents
        soldPriceCents
        state
        timestamp
      }
      primaryBedroomLocation
      schoolDistricts
      schools {
        id
        name
        rating
      }
      shouldShowGuarantee
      similarListings @include(if: $includeSimilarListings) {
        addressId
        bathrooms
        bedrooms
        city
        dwellingType
        estimatedMonthlyPaymentCents
        fullAddress
        listPriceCents
        neighborhood
        photoUrls(first: 1)
        slug
        totalLivingSquareFootage
      }
      photos {
        extraLargeUrl
        largeUrl
        mediumUrl
      }
      summary {
        addressId
        bathrooms
        bedrooms
        canSelfTour
        city
        displayBadge
        dwellingType
        estimatedMonthlyPaymentCents
        latitude
        listPriceCents
        listingState
        longitude
        lotSquareFootage
        pricePerSquareFootCents
        slug
        state
        street
        totalLivingSquareFootage
        yearBuilt
        zip
      }
      unitNumber
      unitType
    }
  }
}
    `) as unknown as TypedDocumentString<GetMarketplacePropertyDetailsQuery, GetMarketplacePropertyDetailsQueryVariables>;